module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/landing-page/landing-page.component.css
// module id = ./src/app/pages/landing-page/landing-page.component.css
// module chunks = main